import React, {useEffect, useState} from 'react';
import {
   Dimensions,
   Image,
   Platform,
   Text,
   TouchableOpacity,
   View,
   NativeModules,
} from 'react-native';

import {
   BROUS,
   DASHBOARD,
   MYTRAINING,
   primaryColor500,
   primaryColor700,
   BACK_BUTTON_HOVER_COLOR,
   tabSelector,
   white,
   FONT_FAMILY_REGULAR,
   getFistNameAndLastName,
   getProfileImage,
   isHoverEnabled,
   isWeb,
   isWindows,
   isMacOS,
   isDesktop,
} from './utils';
import {useSelector} from 'react-redux';
import {selectScreenOrientation} from '../redux/slices/ScreenOrientationSlice';
import {useNavigation} from '@react-navigation/native';
import {Popup} from '../components/popup';
import LogutPopup from './LogutPopup';
// import {Popup} from 'react-native-windows';
import {PopoverLandscape} from './popoverView';
import UISvg from '../components/svg';

const Landscap_Application_Header = props => {
   const [navigation, setNavigation] = useState('');
   const isIOS = Platform.OS === 'ios';
   const isAndroid = Platform.OS === 'android';
   const isMobilePlatform = isIOS || isAndroid;
   const [anchorView, setAnchorView] = useState({x: 0, y: 100});
   const [windowDimensions, setWindowDimensions] = useState(
      Dimensions.get('window'),
   );
   const [popoverVisible, setPopoverVisible] = useState(false);
   const topMargin = Platform.OS === 'ios' ? 85 : 60;
   const isMacos = Platform.OS === 'macos';
   const navigationObj = useNavigation();
   const myRef = React.useRef(null);
   const [windowsPopoverVisible, setWindowsPopoverVisible] = useState(false);
   const [profileNameWidth, setProfileNAmeWidth] = useState();
   useEffect(() => {
      const handleResize = () => {
         setWindowDimensions(Dimensions.get('window'));
      };
      const subscription = Dimensions.addEventListener('change', handleResize);
      setNavigation(props.selectedTab);
      return () => {
         subscription.remove();
      };
   }, []);
   const handleLayout = event => {
      const {x, y, width, height} = event.nativeEvent.layout;
      const xValue = x + 230;
      // setAnchorView({
      //    x: xValue,
      //    y: y + height - 10,
      // });
      setPopoverVisible(false);
   };

   const isLandscapemode = useSelector(selectScreenOrientation);
   const [profileImgHover, setProfileImgHover] = React.useState(false);
   return (
      <View
         style={{
            height: isMobilePlatform ? null : isDesktop ? 70 : 64,
            flexDirection: 'row',
            paddingEnd: 16,
            backgroundColor: '#003DA6',
            paddingTop: isMobilePlatform ? 25 : 0,
            ...Platform.select({
               web: {
                  maxHeight: isLandscapemode ? '88vh' : null,
                  flexWrap: isLandscapemode ? 'wrap' : null,
               },
            }),
         }}>
         <UISvg
            height={Platform.OS === 'web' ? '100%' : '200%'}
            width={Platform.OS === 'web' ? '100%' : '200%'}
            x1="0%"
            y1="100%"
            x2="0%"
            y2="0%"
            offset={['0%', '100%']}
            stopColor={['#00215A', '#00215A']}
            stopOpacity={['0', '1']}
            rectWidth={'100%'}
            rectHeight={isMacos ? 64 : '100%'}
         />
         <View
            style={{
               flex: 1,
               flexDirection: 'row',
               ...Platform.select({
                  web: {
                     minWidth: isLandscapemode ? 370 : null,
                  },
               }),
            }}>
            <TouchableOpacity
               onPress={event => {
                  setNavigation(DASHBOARD);
                  props.onTopMenuClick(DASHBOARD);
               }}>
               <TabView
                  isSelected={props.selectedTab === DASHBOARD ? true : false}
                  value="Dashboard"
               />
            </TouchableOpacity>
            <TouchableOpacity
               onPress={() => {
                  setNavigation(MYTRAINING);
                  props.onTopMenuClick(MYTRAINING);
               }}>
               <TabView
                  isSelected={props.selectedTab === MYTRAINING ? true : false}
                  value="My Training"
               />
            </TouchableOpacity>
            <TouchableOpacity
               onPress={() => {
                  setNavigation(BROUS);
                  props.onTopMenuClick(BROUS);
               }}>
               <TabView
                  isSelected={props.selectedTab === BROUS ? true : false}
                  value="Browse Courses"
               />
            </TouchableOpacity>
         </View>
         <View
            style={{
               flex: 1,
               justifyContent: 'center',
               alignContent: 'center',
               alignItems: 'center',
               ...Platform.select({
                  web: {
                     minWidth: isLandscapemode ? 70 : null,
                  },
               }),
            }}>
            <Image
               source={require('../assets/my_logo_header.png')}
               style={{
                  width: 70,
                  height: 40,
                  resizeMode: 'contain',
                  marginStart: 21,
                  ...Platform.select({
                     web: {
                        marginStart: window?.innerWidth > 550 ? 21 : 0,
                     },
                  }),
               }}
            />
         </View>
         <View
            onLayout={handleLayout}
            style={{
               flex: 1,
               flexDirection: 'row-reverse',
               alignContent: 'center',
               alignItems: 'center',
            }}>
            <TouchableOpacity
               ref={myRef}
               style={{padding: 10}}
               onMouseEnter={() => {
                  setProfileImgHover(true);
               }}
               onMouseLeave={() => {
                  setProfileImgHover(false);
               }}
               onPress={event => {
                  // setNavigation(PROFILE);
                  // props.onProfileClick(event);
                  if (!isMacos) {
                     setAnchorView({
                        x: windowDimensions.width - 225,
                        y: topMargin,
                     });
                     if (Platform.OS === 'windows') {
                        setWindowsPopoverVisible(true);
                     } else {
                        setPopoverVisible(true);
                     }
                  } else {
                     NativeModules.PopoverModule.showList(
                        props.dataSource,
                        event.nativeEvent.pageX,
                        event.nativeEvent.pageY,
                        selectedItem => {
                           // Handle the selected item from the popover
                           if (selectedItem === 'Edit Profile') {
                              navigationObj.navigate('EditProfileScreen');
                           } else if (selectedItem === 'View Profile') {
                              navigationObj.navigate('ProfileScreen');
                           } else {
                              navigationObj.navigate('LogoutScreen');
                           }
                        },
                     );
                  }
               }}>
               <Image
                  resizeMode="cover"
                  source={
                     getProfileImage(props.authData) === 'NoPic'
                        ? require('../assets/p_default.png')
                        : {
                             uri: `${getProfileImage(props.authData)}`,
                          }
                  }
                  style={[
                     {
                        height: 48,
                        width: 48,
                        borderRadius: 36,
                        marginStart: 16,
                     },
                     isHoverEnabled &&
                        profileImgHover && {
                           boxShadow: isWeb
                              ? `rgb(75,85,145,.7) 0px 0px 0px 3px`
                              : null,
                        },
                     isHoverEnabled &&
                        (isWindows || isMacOS) && {
                           borderWidth: 3,
                           borderColor: profileImgHover
                              ? 'rgb(75,85,145)'
                              : 'transparent',
                        },
                  ]}
               />
            </TouchableOpacity>
            <Text
               numberOfLines={1}
               ellipsizeMode="tail"
               style={{
                  color: white,
                  fontSize: 14,
                  fontWeight: '700',
                  fontFamily: FONT_FAMILY_REGULAR,
                  maxWidth: 320,
               }}>
               {'Welcome, ' + getFistNameAndLastName(props.authData)}
            </Text>
         </View>
         {!isMacos ? (
            <PopoverLandscape
               visible={popoverVisible}
               anchorView={anchorView}
               onclose={() => {
                  setPopoverVisible(false);
               }}
               width={windowDimensions.width}
               height={windowDimensions.height}
               content={
                  <LogutPopup
                     screen={navigation}
                     dismissPopover={() => {
                        setPopoverVisible(false);
                     }}
                  />
               }
            />
         ) : null}
         {Platform.OS === 'windows' && (
            <Popup
               isOpen={windowsPopoverVisible}
               isLightDismissEnabled={true}
               target={myRef.current}
               horizontalOffset={-205}
               verticalOffset={-10}
               onDismiss={() => {
                  setWindowsPopoverVisible(false);
               }}>
               <LogutPopup
                  screen={navigation}
                  dismissPopover={() => {
                     setWindowsPopoverVisible(false);
                  }}
               />
            </Popup>
         )}
      </View>
   );
};

const TabView = ({isSelected, value}) => {
   const [isHover, setHover] = React.useState(false);
   return (
      <View
         onMouseEnter={() => {
            setHover(true);
         }}
         onMouseLeave={() => {
            setHover(false);
         }}
         style={{
            height: isWeb ? 64 : 70,
            justifyContent: 'center',
            paddingHorizontal: 16,
            borderColor: tabSelector,
            borderTopWidth: 0,
            borderEndWidth: 0,
            borderStartWidth: 0,
            backgroundColor:
               isHover && isHoverEnabled
                  ? BACK_BUTTON_HOVER_COLOR
                  : isSelected
                  ? '#003DA6'
                  : '#003693',
         }}>
         <Text
            style={{
               color: white,
               opacity: isSelected ? 1 : 0.6,
               fontSize: 16,
               fontWeight: '400',
               fontFamily: FONT_FAMILY_REGULAR,
            }}>
            {value}
         </Text>
      </View>
   );
};

export default Landscap_Application_Header;
